
import { io } from "socket.io-client";
import { SOCKET_BASE } from "../../api_endpoints/API_URL";

// Action (names)
export const GET_SOCKET = "GET_SOCKET";
export const ONLINE_USERS = "ONLINE_USERS";

// in Actions we return an object {type, payload}
// These Are the action Creator functions

export const wakeUpSocket = (data) => {
  const actionOBject = {
    type: GET_SOCKET,
    payload: data 
  };
  return actionOBject;
};

export const onlineUsersListSocket = (data) => {
  const actionOBject = {
    type: ONLINE_USERS,
    payload: data,
  };
  return actionOBject;
};

// Also, When we are using redux thunk, We can return a function in our action creator
// This is a new Action Creator that works only with Redux-Thunk Middleware

// initialize socket
export const initializeSocket = () => (dispatch) => {
  const newSocket = io(SOCKET_BASE);
  dispatch(wakeUpSocket(newSocket));
  return () => {
    newSocket.disconnect();
  };
};
